export class Dashboard {
  constructor(http) {
    this.http = http;
  }

  fetchDashboard(
    startDate,
    endDate,
    teamLead
  ) {

    if (startDate && endDate) {
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
    }

    return this.http
      .post(`dashboard`, { startDate, endDate, teamLead })
      .then(response => response.data);
  }

  fetchDashboardProfit(
    startDate,
    endDate,
    teamLead
  ) {

    if (startDate && endDate) {
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
    }

    return this.http
      .post(`dashboard/profit`, { startDate, endDate, teamLead })
      .then(response => response.data);
  }

  fetchDashboardUsers(
    startDate,
    endDate,
    teamLead
  ) {

    if (startDate && endDate) {
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
    }

    return this.http
      .post(`dashboard/users`, { startDate, endDate, teamLead })
      .then(response => response.data);
  }

  fetchDashboardClients(
    startDate,
    endDate,
    teamLead
  ) {

    if (startDate && endDate) {
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
    }

    return this.http
      .post(`dashboard/clients`, { startDate, endDate, teamLead })
      .then(response => response.data);
  }

}

